import { Components, Theme } from "@mui/material";
import { Colors } from "style/Colors";

export const MuiIconButton: Components<Theme>["MuiIconButton"] = {
  styleOverrides: {
    root: {
      width: "40px",
      height: "40px",
      "&:hover": {
        backgroundColor: "transparent",
      },

      "&.small": {
        padding: "6px",
      },
      "&.active": {
        backgroundColor: Colors.greenLight,
        color: Colors.grayLight,
        "&:hover": {
          backgroundColor: Colors.green,
        },
      },
    },
  },
};
